import {Component} from "@angular/core";
import {JwksValidationHandler, OAuthService} from "angular-oauth2-oidc";
import {authConfig} from "./auth-config";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  template: ''
})


export class AuthComponent {
  constructor(private oauthService: OAuthService,
              private activatedRoute: ActivatedRoute) {
    const returnUrl = this.activatedRoute.snapshot.queryParams['returnUrl'] || localStorage.getItem('returnUrl');
    this.oauthService.configure(authConfig);
    this.oauthService.tokenValidationHandler = new JwksValidationHandler();
    this.oauthService.loadDiscoveryDocumentAndTryLogin().then(_ => {
      if (!this.oauthService.hasValidIdToken() || !this.oauthService.hasValidAccessToken()) {
        if (returnUrl) {
          localStorage.setItem('returnUrl', returnUrl);
        }
        this.oauthService.initImplicitFlow();
      } else {
        if (returnUrl) {
          document.location.href = returnUrl;
          localStorage.removeItem('returnUrl');
        }
      }
    });
  }
}
